export const getProbabilityOfWinningPercentage = (totalFactorsSum, currentFactor) => {
    return Math.round((currentFactor / totalFactorsSum) * 100)
}
